import { publicAxios, createAxiosInstance } from 'common/utils/axios'

// Endpoint
import { PROFILE_ENDPOINTS, USER_SERVICE_URL } from 'common/constants/apiUrls'

export const authAxiosLocalServer = createAxiosInstance(USER_SERVICE_URL)

const handler = authAxiosLocalServer

export const GetUserProfile = async ({ user_id }) => {
  const response = await handler.get(PROFILE_ENDPOINTS.READ_PROFILE, {
    params: {
      user_id,
    },
  })

  const { data } = response

  return data
}

export const UpdateProfile = async ({ data }) => {
  const response = await handler.patch(`${PROFILE_ENDPOINTS.UPDATE_PROFILE}`, data)

  const { data: result } = response.data

  return result
}

export const RequestEmailVerification = async () => {
  const response = await handler.get(PROFILE_ENDPOINTS.REQUEST_EMAIL_VERIFICATION)

  const { data: result } = response.data

  return result
}

export const VerifyEmail = async ({ auth_hash }) => {
  const response = await publicAxios.post(`${PROFILE_ENDPOINTS.REQUEST_EMAIL_VERIFICATION}/${auth_hash}`)

  const { data: result } = response.data

  return result
}

export const GetActivationLink = async ({ auth_hash }) => {
  const response = await publicAxios.get(`${PROFILE_ENDPOINTS.GET_ACTIVATION_LINK}${auth_hash}`)

  const { data: result } = response.data

  return result
}

export const ActivateUser = async ({ auth_hash, password }) => {
  const response = await publicAxios.post(`${PROFILE_ENDPOINTS.ACTIVATE_USER}${auth_hash}`, { password })

  const { data: result } = response.data

  return result
}
